<template>
  <div class="page-title text-center">
    <h1 class="page-title--title">
      {{ title }}
    </h1>

    <span
      v-if="subTitle"
      class="page-title--sub-title d-block w-100"
    >
      {{ subTitle }}
    </span>
  </div>
</template>

<script setup>
defineProps({
  title: {
    type: [String, Object],
    default: () => ({})
  },
  subTitle: {
    type: [String, Object],
    default: ''
  }
})
</script>

<style lang="scss" scoped>
.page-title {
  position: relative;
  z-index: 2;
  padding-top: 24px;
  padding-bottom: 24px;

  &--title {
    font-size: 1.25rem !important;
    line-height: 1.5625rem !important;
    font-weight: 700;
    letter-spacing: 0;
  }

  &--sub-title {
    position: absolute;
    z-index: 2;
    bottom: 0;
    left: 0;
    margin-top: 12px;
    font-size: 0.875rem !important;
    line-height: 1.25rem !important;
    letter-spacing: 0.25px;
  }
}
</style>
